module.exports = __webpack_public_path__ + "img/assessment-complete.bea1cae5.png";